export default (state, param) => {
  state.fields.push(param)
}



// WEBPACK FOOTER //
// ./src/store/modules/order_custom_form/mutations/addOrderCustomFormField.js